import React from 'react';
import styled from 'styled-components';

export const BLUE = '#007ADE';
export const GREY_TEXT = '#6C7079';
export const BORDER = '#E3E5E8';
export const TILE_BACKGROUND = '#F4F5F7';
// The resend to non-openers icon, on the graphs and in the table.
export const RESEND_COLOR = '#5EAB00';

// A full-height column: the table card takes the space left under the header.
// With fitsWindow (the table page) the column is exactly the window's height,
// so the header stays in place and only the table's rows scroll.
// When the window is narrower than MIN_SCREEN_WIDTH, the page scrolls
// sideways instead of squeezing the toolbar, the card and the table on top of
// each other. The page sits next to the side menu, whose width changes when it
// is collapsed, so its minimum is worked out from the window:
// 100% (the page's width now) + how far the window is below MIN_SCREEN_WIDTH
// = MIN_SCREEN_WIDTH - side menu width.
export const MIN_SCREEN_WIDTH = 1580;

const PageBody = styled.div`
  box-sizing: border-box;
  min-width: calc(100% + ${MIN_SCREEN_WIDTH}px - 100vw);
  display: flex;
  flex-direction: column;
  ${({ $fitsWindow }) => ($fitsWindow ? 'height: 100%;' : 'min-height: 100%;')}
  padding: 0 24px 24px 40px;
  background: #ffffff;
`;

// The page scrolls inside this box, which is exactly the content area's
// height. If the page grew past it instead, the dashboard's full-page loader
// (position: absolute, the content area's height) would leave the rest of
// the page uncovered.
const PageScroll = styled.div`
  height: 100%;
  overflow: auto;
  background: #ffffff;
`;

export const Page = ({ fitsWindow, children }) => (
  <PageScroll>
    <PageBody $fitsWindow={fitsWindow}>{children}</PageBody>
  </PageScroll>
);

export const Tabs = styled.div`
  display: flex;
  border-bottom: 1px solid ${BORDER};
  padding-left: 14px;
`;

export const Tab = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 18px 20px;
  margin-top: 6px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  color: ${BLUE};
  background: #ffffff;
  border: 1px solid ${BORDER};
  border-bottom: 1px solid #ffffff;
  border-radius: 8px 8px 0 0;
  margin-bottom: -1px;
`;

export const Top = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  margin-top: 24px;
`;

export const TopLeft = styled.div`
  flex: 1;
  min-width: 0;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 10px;
`;

export const Title = styled.h1`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-size: 26px;
  font-weight: 500;
  color: #1c1c1c;
`;

export const Description = styled.span`
  font-size: 13px;
  color: ${GREY_TEXT};
`;

export const TableCard = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  border: 1px solid ${BORDER};
  border-radius: 8px;
`;
